export const dismissModal = function () {
  this.setState({ seenModal: true })
}
